/**
 * Site search overlay — toggle open / close.
 *
 * Controls `#site-search-overlay` visibility via the `#search-toggle-btn` button.
 * Closes on Escape, on clicks outside the overlay, and sets focus to the input
 * when opened.
 */
export function initSearch() {
  const toggleBtn = document.getElementById('search-toggle-btn');
  const overlay = document.getElementById('site-search-overlay');
  const input = overlay?.querySelector('input[type="search"], input[name="s"]');

  if (!toggleBtn || !overlay) return;

  function openSearch() {
    overlay.removeAttribute('hidden');
    overlay.getBoundingClientRect(); // force reflow so CSS transition plays
    overlay.classList.add('is-open');
    toggleBtn.setAttribute('aria-expanded', 'true');
    input?.focus();
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
    overlay.addEventListener('transitionend', () => overlay.setAttribute('hidden', ''), {
      once: true,
    });
  }

  toggleBtn.addEventListener('click', () => {
    toggleBtn.getAttribute('aria-expanded') === 'true' ? closeSearch() : openSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toggleBtn.getAttribute('aria-expanded') === 'true') {
      closeSearch();
      toggleBtn.focus();
    }
  });

  // Close when clicking outside the overlay
  document.addEventListener('click', (e) => {
    if (
      !overlay.contains(e.target) &&
      !toggleBtn.contains(e.target) &&
      toggleBtn.getAttribute('aria-expanded') === 'true'
    ) {
      closeSearch();
    }
  });
}
